import React, {useState} from "react";
import FlexibleWrapper from "../shared/FlexibleWrapper";
import * as colors from "../../styles/colors";
import MessageIcon from "../shared/icons/tasks/MessageIcon";
import HelpdeskMessageIcon from "../shared/icons/tasks/HelpdeskMessageIcon";
import ConfirmDiagramTypeChangeModal from "../modals/ConfirmDiagramTypeChangeModal";
import {SaveButtonWrapper, SaveTooltip, SaveTooltipContent} from "../shared/Buttons";
import DiagramVersionsService from "../../services/DiagramVersionsService";
import {useDispatch} from "react-redux";

const BotToggleButtons = ({diagramType, setDiagramType, currentDiagram, updateCurrentDiagramVersions}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(null);
  const openModal = (type) => {
    if (diagramType !== type) {
      setOpen(type);
    }
  };

  const confirm = () => {
    // load only those versions that have the selected type
    DiagramVersionsService.getDiagramVersions({
      diagramId: currentDiagram.id,
      count: 3,
      startFrom: 0,
      diagramType: open
    }).then((response) => {
      if (response.status) {
        const diagramVersions = response.data['versions'];
        const hasMore = response.data['has_next'];

        updateCurrentDiagramVersions(diagramVersions, hasMore, 3, true);
      }
    })
    setDiagramType(open);
    setOpen(null);
  }


  return (
    <>{open &&
      <ConfirmDiagramTypeChangeModal onClose={() => setOpen(null)} onConfirm={confirm} diagramType={open}/>}
      <FlexibleWrapper>
        <SaveButtonWrapper onClick={() => openModal("chatbot")}>
          <MessageIcon color={diagramType === "chatbot" ? colors.red : colors.mainFontColor}/>
          <SaveTooltip>
            <SaveTooltipContent>
              Chatbot
            </SaveTooltipContent>
          </SaveTooltip>
        </SaveButtonWrapper>
        <SaveButtonWrapper onClick={() => openModal("callbot")}>
          <HelpdeskMessageIcon color={diagramType === "callbot" ? colors.red : colors.mainFontColor}/>
          <SaveTooltip>
            <SaveTooltipContent>
              Callbot
            </SaveTooltipContent>
          </SaveTooltip>
        </SaveButtonWrapper>
      </FlexibleWrapper>
    </>
  )
}

export default BotToggleButtons;
